// extracted by mini-css-extract-plugin
export default {"logo":"Nav_logo__CGlwg","navbar":"Nav_navbar__MFe+0","nav":"Nav_nav__iMr2i"};